import { useState } from "react";
import { ArrowUpRight, Menu, PhoneCall, X } from "lucide-react";
import BrandMark from "@/components/BrandMark";

const links = [
  ["Leistungen", "/#leistungen", "header-nav-leistungen-link"],
  ["Über uns", "/#ueber-uns", "header-nav-ueber-uns-link"],
  ["Für wen", "/#fuer-wen", "header-nav-fuer-wen-link"],
  ["Kontakt", "/#kontakt", "header-nav-kontakt-link"],
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className={`site-header ${menuOpen ? "menu-open" : ""}`} data-testid="site-header">
      <div className="container header-inner">
        <a className="header-brand-link" href="/" data-testid="header-brand-link" onClick={() => setMenuOpen(false)}>
          <BrandMark testId="header-brand-mark" compact />
        </a>
        <nav className="header-nav" aria-label="Hauptnavigation" data-testid="header-navigation">
          {links.map(([label, href, testId]) => (
            <a key={testId} href={href} data-testid={testId} onClick={() => setMenuOpen(false)}>
              {label}
            </a>
          ))}
        </nav>
        <div className="header-actions">
          <a className="header-phone" href="tel:+4915568199384" data-testid="header-phone-link">
            <PhoneCall size={15} strokeWidth={1.8} />
            <span>Anrufen</span>
            <ArrowUpRight className="header-phone-arrow" size={14} strokeWidth={1.8} />
          </a>
          <button
            className="mobile-menu-button"
            type="button"
            aria-label={menuOpen ? "Menü schließen" : "Menü öffnen"}
            aria-expanded={menuOpen}
            data-testid="mobile-menu-button"
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
    </header>
  );
}
